import { Link } from "react-router-dom";
import { useState } from "react";
import "./Footer.css";
import { FaInstagram, FaFacebook, FaTwitter, FaPinterest, FaYoutube } from "react-icons/fa";
import logo from "../assets/logoo.png";
import stemAccredited from "../assets/stempic.png";
import cartoonKid from "../assets/cartoon.png";
import redCallIcon from "../assets/redcallicon.png";
import emailIcon from "../assets/emailicon.png";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const currentYear = new Date().getFullYear();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const addNewsLetterEmail = async (email) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_LOCAL_SERVER_API}/addNewsletterEmail`, { email });
      return response;
    } catch (error) {
      throw error;
    }
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    try {
      await addNewsLetterEmail(email);
      toast.success('You have been Subscribed successfully!', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setEmail("");
    } catch (error) {
      toast.error('Email might already been subscribed!', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setEmail("");
    }
  };

  return (
    <footer className="footer">
      <div className="footer-wave">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path
            d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
            opacity=".25"
            fill="#FFFFFF"
          ></path>
          <path
            d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
            opacity=".5"
            fill="#FFFFFF"
          ></path>
          <path
            d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
            fill="#FFFFFF"
          ></path>
        </svg>
      </div>

      <div className="cartoon-kid">
        <img src={cartoonKid || "/placeholder.svg"} alt="Cartoon Kid" />
      </div>

      <div className="footer-container">
        <div className="footer-content">
          {/* Logo and Description */}
          <div className="footer-logo-section">
            <Link to="/" className="footer-logo">
              <img src={logo || "/placeholder.svg"} alt="Polymath Kids Logo" />
            </Link>
            <p className="footer-description">
              Polymath-Kids offers online courses to develop 21st-century skills in children, preparing them for a
              successful future.
            </p>
            <div className="footer-social">
              <a
                href="https://www.instagram.com/polymathkidz"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/polymathkidz"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
              <a href="https://twitter.com/polymathkidz" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a
                href="https://www.pinterest.com/polymathkidz/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Pinterest"
              >
                <FaPinterest />
              </a>
              <a
                href="https://www.youtube.com/@polymath-kids"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>
            </div>
          </div>

          {/* Our Company */}
          <div className="footer-links-section">
            <h3>Our Company</h3>
            <ul className="footer-links">
              <li>
                <Link to="/polymatch">Polymatch</Link>
              </li>
              <li>
                <Link to="/our_vision">Our Vision</Link>
              </li>
              <li>
                <Link to="/polymathkids_at_schools">Polymath-Kids@school</Link>
              </li>
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/terms_of_use">Terms of Use</Link>
              </li>
              <li>
                <Link to="/privacy_policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/cancelation_refund_policy">Cancellation and Refund Policy</Link>
              </li>
            </ul>
          </div>

          {/* Contact Us */}
          <div className="footer-contact-section">
            <h3>Contact Us</h3>
            <ul className="footer-contact">
              <li>
                <a href="tel:+923266699907">
                  <img src={redCallIcon || "/placeholder.svg"} alt="Phone" className="contact-icon-img" />
                  +92 3266699907
                </a>
              </li>
              <li>
                <a href="tel:+4747650619">
                  <img src={redCallIcon || "/placeholder.svg"} alt="Phone" className="contact-icon-img" />
                  +4747650619
                </a>
              </li>
              <li>
                <a href="mailto:info@polymath-kids.com">
                  <img src={emailIcon || "/placeholder.svg"} alt="Email" className="contact-icon-img" />
                   info@polymath-kids.com
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="footer-newsletter-section">
            <h3>Our Newsletter</h3>
            <p>Subscribe to our newsletter and stay up to date with our events.</p>
            <form className="newsletter-form" onSubmit={handleSubscribe}>
              <input
                type="email"
                name="email"
                placeholder="Enter Email"
                required
                value={email}
                onChange={handleEmailChange}
              />
              <button type="submit" className="submit-button">SUBMIT</button>
            </form>
            <div className="stem-accredited">
              <img src={stemAccredited || "/placeholder.svg"} alt="STEM Accredited" />
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p>Copyright © {currentYear} All rights reserved.</p>
        </div>
      </div>
      <ToastContainer />
    </footer>
  );
};

export default Footer;
